import { Link, useRouterState } from '@tanstack/react-router';
import { cx } from '../lib/cx';
import { PHONE_NAV, useNavBadges } from './nav';

/** Phone tab bar: Dashboard, Leads, Bookings, Chats and Needs You, with the coral count on Needs You. */
export function BottomTabs() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const badges = useNavBadges();

  return (
    <nav aria-label="Main" className="grid shrink-0 grid-cols-5 border-t border-sand-dark bg-white px-0.5 pt-1" style={{ paddingBottom: 'max(4px, env(safe-area-inset-bottom))' }}>
      {PHONE_NAV.map((item) => {
        const active = item.match(path);
        const Icon = item.icon;
        // The phone board keeps one badge, on Needs You.
        const count = item.badge === 'needs' ? badges.needs : 0;
        return (
          <Link
            key={item.to}
            to={item.to}
            preload="intent"
            aria-current={active ? 'page' : undefined}
            className={cx('flex h-[50px] min-w-0 flex-col items-center justify-center gap-0.5 text-meta', active ? 'font-bold text-deep' : 'font-medium text-muted')}
          >
            <span className="relative flex">
              <Icon size={21} strokeWidth={active ? 2 : 1.8} className={active ? 'text-teal' : undefined} aria-hidden="true" />
              {count > 0 ? (
                <span className="absolute -right-2.5 -top-1.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-coral px-1 text-meta font-bold leading-none text-deep tabular">
                  {count}
                  <span className="sr-only"> waiting</span>
                </span>
              ) : null}
            </span>
            <span className="max-w-full truncate">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
